import { AttachmentData } from "@/components/molecules/emailEditor/types";
import { AttachmentData as MessageAttachmentData } from "@/repository/models/message";
import { sanitize } from "lettersanitizer";

export const calculateAttachmentsSize = (
    attachments: AttachmentData[] | undefined
): number => {
    if (!attachments) {
        return 0;
    }

    return attachments
        .reduce((acc, att) => acc + (att.file?.size || 0), 0);
};

export const addDataCidToImages = (html: string): string => {
    if (!html) {
        return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
        const src = img.getAttribute("src") ?? "";
        const isBase64 = src.startsWith("data:");

        if (isBase64 && !img.hasAttribute("data-cid")) {
            img.setAttribute("data-cid", crypto.randomUUID());
        }
    });

    return doc.body.innerHTML;
};

export const decodeHtmlEntities = (value: string): string => {
    if (!value) {
        return "";
    }

    const textarea = document.createElement("textarea");
    textarea.innerHTML = value;

    return textarea.value;
};

export const handleEmailPaste = (pastedHtml: string, pastedText: string): string | null => {
    const processedHtml = addDataCidToImages(pastedHtml);
    return processedHtml || pastedText;
};

export const wouldExceedAttachmentLimit = (
    currentAttachments: AttachmentData[] | undefined,
    newFilesSize: number,
    maxSize: number
): boolean => {
    const currentSize = calculateAttachmentsSize(currentAttachments);

    return currentSize + newFilesSize > maxSize;
};

export const sanitizeEmailBody = (
	content: string,
	id: string | undefined,
	inlineAttachments: MessageAttachmentData[]
): string => {
	return sanitize(content, undefined, {
		id,
		rewriteExternalResources: (url: string) => {
			if (!url.startsWith("cid:")) {
				return url;
			}
			const attachment = inlineAttachments.find(
				(x: MessageAttachmentData) => url.includes(x.contentId)
			);

			return attachment
				? `data:${attachment.contentType};base64,${attachment.contentBytes}`
				: "";
		},
	});
};